<template>
  <div style="position:absolute;top:0;left:0;right:0;bottom:0;" class="layout-column">
    <div class="layout-column flex ma-2 elevation-5"
         style="border-radius:4px;position:relative;"
         v-bind:style="{background: compColor.contentFrame}">

      <ValidationObserver tag="div"  ref="AccountDetailForm" v-slot="{ valid, pristine, reset }" class="layout-column flex">
        <div v-bind:style="{'z-index': '4'}" class="layout-row layout-align-center-center pa-1">
          <div class="layout-row">
            <lx-btn small classes="mr-1"
                    :disabled="pristine && !arrayCountHasChanged"
                    @click="clearForm(reset)"
                    icon="mdi-undo-variant"
                    :tooltip="$t('buttons.revert.tooltip_physician')"
                    :label="$t('buttons.revert.value')"
                    hide-label></lx-btn>
            <lx-btn small classes="mr-1"
                    :disabled="!valid || (pristine && !arrayCountHasChanged)"
                    @click="saveAccountData"
                    icon="save"
                    :tooltip="$t('buttons.save.tooltip_physician')"
                    :label="$t('buttons.save.value')"
                    hide-label></lx-btn>
          </div>

          <div class="flex layout-row"></div>
        </div>

        <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

        <!-- not SYSTEM_USER -->

        <div class="pa-2 mx-2 ma-1 report layout-row layout-align-start-center"
             style="border:1px solid;border-radius: 9px;"
             v-if="isPhysician && !model.is_system"
             :class="[!compColor.isInDarkMode ? compColor.prime + ' lighten-5 white--text ' : '']"
             :style="{'border-color': compColor.isInDarkMode ? compColor.primeHighlightColor : 'transparent'}">
          <div class="layout-column layout-align-center-center mr-3">
            <v-icon size="30" :color="compColor.prime">mdi-information</v-icon>
          </div>

          <div class="layout-column" style="font-size: 14px;" :class="compColor.primeClass">
            <span>{{ $t('COMPONENT_ACCOUNT.INFO_TO_COMPLETE_ACCOUNT_DETAILS_FOR_REGISTER') }}</span>
          </div>
        </div>

        <!-- information for SYSTEM_USER -->

        <div style="border:1px solid;border-radius: 9px;"
             class="pa-2 ma-1"
             :class="[!compColor.isInDarkMode ? 'red' + ' lighten-5 white--text ' : '']"
             :style="{'border-color': compColor.isInDarkMode ? '#E53935' : 'transparent'}"
             v-if="model.is_system"
        >
          <v-icon class="mr-3" size="30" :color="'#E53935'">mdi-alert</v-icon>
          <span style="font-size: 18px;" :class="'red--text darken-1'"><small>{{ $t('COMPONENT_ACCOUNT.SYSTEM_USER_TEXT_PART_1') }} <strong>"{{authUserName}}"</strong> {{$t('COMPONENT_ACCOUNT.SYSTEM_USER_TEXT_PART_2') }}</small></span>
        </div>

        <v-divider v-if="isPhysician && !model.is_system" v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

        <!-- Base date, panel 0 -->

        <div class="flex layout-column pa-1" style="overflow-y: auto;">
          <v-progress-linear :indeterminate="loading" v-if="loading" color="red accent-2"
                             background-color="red lighten-4" class="ma-0"
                             style="border-radius:0;height:4px;position: absolute;top:56px;left:0; width:100%;"></v-progress-linear>

          <lx-expansion-panels :single-open="false" v-model="panel">
            <lx-expansion-panel :disabled="true">
              <lx-expansion-panel-header icon="mdi-account-circle"
                                         :disabled="true"
                                         :main-headline="$t('COMPONENT_ACCOUNT.BASE_DATA_MAIN_LINE')"
                                         :sub-headline="$t('COMPONENT_ACCOUNT.BASE_DATA_SUB_LINE')">
              </lx-expansion-panel-header>
              <lx-expansion-panel-content>
                <div class="pa-4 layout-row layout-wrap">
                  <div class="flex-gt-sm-50 flex-100 px-2">
                    <validation-provider tag="div" name="salutation">

                      <v-select
                        name="salutation"
                        :color="compColor.primeColor"
                        v-model="model.salutation"
                        outlined
                        clearable
                        hide-details
                        :dense="denseFields"
                        :label="$t('COMPONENT_ACCOUNT.SALUTATION')"
                        :dark="compColor.isInDarkMode"
                        :items="salutations"
                        :menu-props="{ bottom: true, offsetY: true }">
                        <template v-slot:item="{ item, on, attrs }">
                          <v-list-item v-on="on"
                                       :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                            <v-list-item-content class="py-0">
                              <label style="cursor:pointer;"
                                     :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                                     class="lighten-4 text--darken-2">{{ item.text }}</label>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-select>
                    </validation-provider>
                  </div>

                  <div class="flex-gt-sm-50 flex-100 px-2">
                    <validation-provider tag="div" name="title">
                      <v-select
                        name="title"
                        :color="compColor.primeColor"
                        v-model="model.title"
                        outlined
                        clearable
                        hide-details
                        :dense="denseFields"
                        :label="$t('COMPONENT_ACCOUNT.TITLE')"
                        :dark="compColor.isInDarkMode"
                        :items="titles"
                        :menu-props="{ bottom: true, offsetY: true }">
                        <template v-slot:item="{ item, on, attrs }">
                          <v-list-item v-on="on"
                                       :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                            <v-list-item-content class="py-0">
                              <label style="cursor:pointer;"
                                     :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                                     class="lighten-4 text--darken-2">{{ item.text }}</label>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                        </v-select>
                    </validation-provider>
                  </div>

                  <div class="flex-gt-sm-50 flex-100 px-2">
                    <validation-provider tag="div" name="firstname" rules="required|name_string" v-slot="{ errors }">
                      <v-text-field
                          :dark="compColor.isInDarkMode"
                          :color="compColor.primeColor"
                          :dense="denseFields"
                          :label="$t('COMPONENT_ACCOUNT.FIRSTNAME') + ' *'"
                          outlined
                          :hide-details="!errors || errors.length <= 0"
                          :error-messages="errors[0]"
                          prepend-inner-icon="person"
                          v-model="model.firstname"
                      ></v-text-field>
                    </validation-provider>
                  </div>

                  <div class="flex-gt-sm-50 flex-100 px-2">
                    <validation-provider tag="div" name="lastname" rules="required|name_string" v-slot="{ errors }">
                      <v-text-field
                          :dark="compColor.isInDarkMode"
                          :color="compColor.primeColor"
                          :dense="denseFields"
                          :label="$t('COMPONENT_ACCOUNT.LASTNAME') + ' *'"
                          outlined
                          :hide-details="!errors || errors.length <= 0"
                          :error-messages="errors[0]"
                          prepend-inner-icon="person"
                          v-model="model.lastname"
                      ></v-text-field>
                    </validation-provider>
                  </div>

                  <div class="flex-gt-sm-50 flex-100 px-2">
                    <v-text-field
                        :dark="compColor.isInDarkMode"
                        :color="compColor.textInput"
                        label="Email *"
                        outlined
                        hide-details
                        prepend-inner-icon="email"
                        :dense="denseFields"
                        v-model="model.email"
                        disabled
                    ></v-text-field>
                  </div>

                  <div class="flex-gt-sm-50 flex-100 px-2">
                    <validation-provider tag="div" name="phone" rules="address_string" v-slot="{ errors }">
                      <v-text-field
                          :dark="compColor.isInDarkMode"
                          :color="compColor.primeColor"
                          :dense="denseFields"
                          :label="$t('COMPONENT_ACCOUNT.PHONE')"
                          outlined
                          :hide-details="!errors || errors.length <= 0"
                          :error-messages="errors[0]"
                          prepend-inner-icon="phone"
                          v-model="model.phone"
                      ></v-text-field>
                    </validation-provider>
                  </div>

                  <physician-details class="layout-row layout-wrap flex-gt-sm-100 flex-100" v-if="isPhysician" v-model="model"></physician-details>
                </div>
              </lx-expansion-panel-content>
            </lx-expansion-panel>

            <!-- 2FA, panel 1 -->

            <lx-expansion-panel>
              <lx-expansion-panel-header icon="mdi-lock"
                :main-headline="$t('COMPONENT_ACCOUNT.ACCOUNT_SECURITY.MAIN_LINE')"
                :sub-headline="$t('COMPONENT_ACCOUNT.ACCOUNT_SECURITY.SUB_LINE')">
              </lx-expansion-panel-header>

              <lx-expansion-panel-content>
                <div class="layout-column">
                  <password-edit-component></password-edit-component>

                  <v-divider class="mx-6"></v-divider>

                  <twofactor-edit-component></twofactor-edit-component>
                </div>
              </lx-expansion-panel-content>
            </lx-expansion-panel>

            <!-- Study information of physician, panel 2 -->

            <lx-expansion-panel v-if="isPhysician">
              <lx-expansion-panel-header icon="mdi-flask-outline"
                                         :main-headline="$t('COMPONENT_STUDY_DETAILS.HEADER')"
                                         :sub-headline="$t('COMPONENT_STUDY_DETAILS.HEADER_SUB_LINE')">
              </lx-expansion-panel-header>
              <lx-expansion-panel-content>
                <div class="px-4 pt-2 layout-row layout-wrap">
                  <span class="px-2" style="font-style: italic;" :style="{'color': compColor.isInDarkMode ? '#ffffff' : '#616161'}">
                    Parallel zur Meldung an das Krebsregister können Sie über TumorScout zukünftig auch an Studien teilnehmen.
                    Wenn Sie über die Möglichkeit zur Studienteilnahme informiert werden möchten.
                    Wenn ja, klicken Sie bitte die folgende Checkbox an. Beachten Sie: Wenn Sie hier zustimmen,
                    dürfen Sie lediglich über die Möglichkeit zur Teilnahme an Studien informieren.
                    Jede konkrete Studie erfordert eine erneute ausdrückliche Zustimmung von Ihnen.
                    <br/>
                    Sie können diese Erklärung jederzeit widerrufen.
                  </span>
                </div>

                <div class="pa-4 layout-row layout-wrap">
                  <div class="flex-gt-sm-50 flex-100 px-2">
                    <validation-provider tag="div" name="studyConsent" rules="" v-slot="{}">
                      <v-checkbox :color="compColor.primeColor"
                                  v-model="model.studyConsent" hide-details
                                  class="ma-0 pa-0" :label="$t('COMPONENT_STUDY_DETAILS.NEWS_CONSENT')"
                                  :dark="compColor.isInDarkMode"></v-checkbox>
                    </validation-provider>
                  </div>
                </div>
              </lx-expansion-panel-content>
            </lx-expansion-panel>

            <!-- Cancer register information of physician, panel 3 -->

            <lx-expansion-panel v-if="isPhysician" :disabled="true">
              <lx-expansion-panel-header icon="mdi-clipboard-text"
                                         :disabled="true"
                                         :main-headline="$t('COMPONENT_CANCER_MESSAGE_DETAILS.HEADER')"
                                         :sub-headline="$t('COMPONENT_CANCER_MESSAGE_DETAILS.HEADER_SUB_LINE')">
              </lx-expansion-panel-header>
              <lx-expansion-panel-content>
                <div class="pa-4 layout-row layout-wrap">
                  <register-details path="cancer_form_details"
                                    class="layout-row layout-wrap flex-gt-sm-100 flex-100"
                                    :username="completeUserName"
                                    :oldModel="oldModel.cancer_form_details"
                                    @change="setArrayDirty"
                                    :lanr="model.lanr"
                                    :iknr="model.iknr"
                                    v-model="model.cancer_form_details">
                  </register-details>
                </div>
              </lx-expansion-panel-content>
            </lx-expansion-panel>

            <!-- Address of physician, panel 4 -->

            <lx-expansion-panel v-if="isPhysician" :disabled="true">
              <lx-expansion-panel-header icon="mdi-home-variant"
                                         :disabled="true"
                                         :main-headline="$t('COMPONENT_ADDRESS_DETAILS.HEADER')"
                                         :sub-headline="$t('COMPONENT_ADDRESS_DETAILS.HEADER_SUB_LINE')">
              </lx-expansion-panel-header>
              <lx-expansion-panel-content>
                <div class="pa-4 layout-row layout-wrap">
                  <address-details path="address"
                                    class="layout-row layout-wrap flex-gt-sm-100 flex-100"
                                    v-model="model.address"></address-details>
                </div>
              </lx-expansion-panel-content>
            </lx-expansion-panel>

            <!-- Bank details of physician, panel 5 -->

            <lx-expansion-panel v-if="isPhysician" :disabled="true">
              <lx-expansion-panel-header icon="mdi-bank"
                                         :disabled="true"
                                         :main-headline="$t('COMPONENT_BANK_ACCOUNT_DETAILS.HEADER')"
                                         :sub-headline="$t('COMPONENT_BANK_ACCOUNT_DETAILS.HEADER_SUB_LINE')">
              </lx-expansion-panel-header>
              <lx-expansion-panel-content>
                <div class="pa-4 layout-row layout-wrap">
                  <bank-account-details path="bank_account"
                                        class="layout-row layout-wrap flex-gt-sm-100 flex-100"
                                        v-model="model.bank_account"></bank-account-details>
                </div>
              </lx-expansion-panel-content>
            </lx-expansion-panel>

            <!-- Contact details of systemadmin, panel 6 -->

            <lx-expansion-panel v-if="isSystemAdmin" :disabled="true">
              <lx-expansion-panel-header icon="mdi-home-variant"
                                         :disabled="true"
                                         :main-headline="$t('COMPONENT_CONTACT_DETAILS.HEADER')"
                                         :sub-headline="$t('COMPONENT_CONTACT_DETAILS.HEADER_SUB_LINE')">
              </lx-expansion-panel-header>
              <lx-expansion-panel-content>
                <div class="pa-4 layout-row layout-wrap">
                  <contact-details path="contact"
                                   class="layout-row layout-wrap flex-gt-sm-100 flex-100"
                                   v-model="model.contact"></contact-details>
                </div>
              </lx-expansion-panel-content>
            </lx-expansion-panel>
          </lx-expansion-panels>
        </div>
      </ValidationObserver>
    </div>


  </div>
</template>

<script>
import lodash from 'lodash'
import physicianDetails from '../../components/account/PhysicianDetails'
import registerDetails from '../../components/account/RegisterDetails'
import addressDetails from '../../components/account/AddressDetailsRequired'
import bankAccountDetails from '../../components/account/BankAccountDetails'
import contactDetails from '../../components/account/ContactDetails'
import TwofactorEditComponent from '@/plugins/lx_auth/views/TwofactorEditComponent'
import PasswordEditComponent from '@/plugins/lx_auth/views/PasswordEditComponent'

export default {
  name: 'AccountDetails',
  components: {
    TwofactorEditComponent,
    PasswordEditComponent,
    physicianDetails,
    registerDetails,
    addressDetails,
    bankAccountDetails,
    contactDetails
  },

  data() {
    return {
      panel: [0, 1, 2, 3, 4, 5, 6],
      loading: false,
      model: {},
      oldModel: {},
      error: {},
      salutations: [
        { value: 'Herr', text: this.$t('COMPONENT_ACCOUNT.SALUTATIONS.MR') },
        { value: 'Frau', text: this.$t('COMPONENT_ACCOUNT.SALUTATIONS.MRS') },
        { value: 'Unbekannt', text: this.$t('COMPONENT_ACCOUNT.SALUTATIONS.UNDEFINED') }
      ],
      titles: [
        { value: 'Dr.', text: 'Dr.' },
        { value: 'Prof.', text: 'Prof.' },
        { value: 'Prof. Dr.', text: 'Prof. Dr.' }
      ],
      arrayCountHasChanged: false,
      show_passwords: false
    }
  },
  created() {
    this.getAccountData()
  },
  methods: {
    setArrayDirty (value) {
      this.arrayCountHasChanged = value
    },
    openCloseExpansionPanel(index) {
      if (this.panel.indexOf(index) < 0) {
        this.panel.push(index)
      } else {
        this.panel.splice(this.panel.indexOf(index), 1)
      }
    },
    clearForm(reset) {
      reset()
      this.arrayCountHasChanged = false
      this.model = lodash.cloneDeep(this.oldModel)
    },
    saveAccountData () {
      if (this.loading) return
      this.loading = true

      // set contact.email on null if empty to prevent format validation error in backend
      if (this.model.contact && !this.model.contact.email && this.model.contact.email === '') {
        this.model.contact.email = null
      }

      let data = lodash.cloneDeep(this.model)
      delete data.id
      delete data.auth_user_id
      delete data.owner_id
      delete data.auth_system_name
      delete data.login_name
      delete data.new_password

      this.$http.put('/account/user', data)
          .then((res) => {
            this.loading = false
            this.getAccountData(true)

            if (this.$refs.AccountDetailForm) {
              this.$refs.AccountDetailForm.reset()
            }
            this.NotifySuccess(res, this.$t('COMPONENT_ACCOUNT.ACCOUNT_SUCCESSFULLY_SAVED'))
          })
          .catch((error) => {
            this.loading = false
            this.populateFormError(this.$refs.AccountDetailForm, error)
                .catch(this.NotifyError)
          })
    },

    getAccountData(userIsUpdated) {
      if (this.loading) return
      this.loading = true

      this.$http.get('/account/user')
          .then(res => {
            if (res.data) {
              this.model = res.data
              // update user in store with actually data from db
              if (userIsUpdated) this.authStore.dispatch('updateUser', this.model)

              this.oldModel = lodash.cloneDeep(this.model)
              this.arrayCountHasChanged = false
            }
          })
          .catch(this.NotifyError)
          .finally(() => {
            this.loading = false
          })
    }
  },
  computed: {
    authUserName() {
      return this.authStore.getters.getAuthUserName
    },
    isSystemAdmin() {
      return this.authStore.getters.userIsSystemadmin
    },
    isPhysician () {
      return this.authStore.getters.userIsPhysician
    },
    completeUserName() {
      let string = ''

      if (this.model.title) {
        string += this.model.title
      }

      return string + ' ' + this.model.firstname + ' ' + this.model.lastname
    }
  }
}
</script>
